import {
  ImageUtils
} from "./chunk-MPGKEZT5.js";
import "./chunk-SA55FI2N.js";
import {
  ClipboardPipeline
} from "./chunk-UHWQXN2Z.js";
import "./chunk-ZGNJRE43.js";
import "./chunk-6GJUXDIH.js";
import "./chunk-W7WGVHCV.js";
import {
  FileDialogButtonView,
  FileRepository
} from "./chunk-KQSKBC7C.js";
import "./chunk-NICE7ARI.js";
import "./chunk-U5S3T6FN.js";
import "./chunk-GJCFV3G2.js";
import {
  Notification
} from "./chunk-CCHBLTQG.js";
import "./chunk-J3DZJUY2.js";
import {
  Command,
  Plugin,
  UpcastWriter,
  env_default,
  global_default,
  icons,
  toArray
} from "./chunk-XX3CIG5U.js";
import "./chunk-624QZG55.js";

// node_modules/@ckeditor/ckeditor5-image/src/imageupload/utils.js
function createImageTypeRegExp(types) {
  const regExpSafeNames = types.map((type) => type.replace("+", "\\+"));
  return new RegExp(`^image\\/(${regExpSafeNames.join("|")})$`);
}
function fetchLocalImage(image) {
  return new Promise((resolve, reject) => {
    const imageSrc = image.getAttribute("src");
    fetch(imageSrc).then((resource) => resource.blob()).then((blob) => {
      const mimeType = getImageMimeType(blob, imageSrc);
      const ext = mimeType.replace("image/", "");
      const filename = `image.${ext}`;
      const file = new File([blob], filename, { type: mimeType });
      resolve(file);
    }).catch((err) => {
      return err && err.name === "TypeError" ? convertLocalImageOnCanvas(imageSrc).then(resolve).catch(reject) : reject(err);
    });
  });
}
function isLocalImage(imageUtils, node) {
  if (!imageUtils.isInlineImageView(node) || !node.getAttribute("src")) {
    return false;
  }
  return !!node.getAttribute("src").match(/^data:image\/\w+;base64,/g) || !!node.getAttribute("src").match(/^blob:/g);
}
function getImageMimeType(blob, src) {
  if (blob.type) {
    return blob.type;
  } else if (src.match(/data:(image\/\w+);base64/)) {
    return src.match(/data:(image\/\w+);base64/)[1].toLowerCase();
  } else {
    return "image/jpeg";
  }
}
function convertLocalImageOnCanvas(imageSrc) {
  return getBlobFromCanvas(imageSrc).then((blob) => {
    const mimeType = getImageMimeType(blob, imageSrc);
    const ext = mimeType.replace("image/", "");
    const filename = `image.${ext}`;
    return new File([blob], filename, { type: mimeType });
  });
}
function getBlobFromCanvas(imageSrc) {
  return new Promise((resolve, reject) => {
    const image = global_default.document.createElement("img");
    image.addEventListener("load", () => {
      const canvas = global_default.document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0);
      canvas.toBlob((blob) => blob ? resolve(blob) : reject());
    });
    image.addEventListener("error", () => reject());
    image.src = imageSrc;
  });
}

// node_modules/@ckeditor/ckeditor5-image/src/imageupload/imageuploadui.js
var ImageUploadUI = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "ImageUploadUI";
  }
  /**
   * @inheritDoc
   */
  init() {
    const editor = this.editor;
    const t = editor.t;
    const componentCreator = (locale) => {
      const view = new FileDialogButtonView(locale);
      const command = editor.commands.get("uploadImage");
      const imageTypes = editor.config.get("image.upload.types");
      const imageTypesRegExp = createImageTypeRegExp(imageTypes);
      view.set({
        acceptedType: imageTypes.map((type) => `image/${type}`).join(","),
        allowMultipleFiles: true,
        label: t("Upload image from computer"),
        icon: icons.imageUpload,
        tooltip: true
      });
      view.bind("isEnabled").to(command);
      view.on("done", (evt, files) => {
        const imagesToUpload = Array.from(files).filter((file) => imageTypesRegExp.test(file.type));
        if (imagesToUpload.length) {
          editor.execute("uploadImage", { file: imagesToUpload });
          editor.editing.view.focus();
        }
      });
      return view;
    };
    editor.ui.componentFactory.add("uploadImage", componentCreator);
    editor.ui.componentFactory.add("imageUpload", componentCreator);
    if (editor.plugins.has("ImageInsertUI")) {
      const imageInsertUI = editor.plugins.get("ImageInsertUI");
      const command = editor.commands.get("uploadImage");
      imageInsertUI.registerIntegration({
        name: "upload",
        observable: command,
        buttonViewCreator: () => {
          const uploadImageButton = editor.ui.componentFactory.create("uploadImage");
          uploadImageButton.bind("label").to(imageInsertUI, "isImageSelected", (isImageSelected) => isImageSelected ? t("Replace image from computer") : t("Upload image from computer"));
          return uploadImageButton;
        },
        formViewCreator: () => {
          const uploadImageButton = editor.ui.componentFactory.create("uploadImage");
          uploadImageButton.withText = true;
          uploadImageButton.bind("label").to(imageInsertUI, "isImageSelected", (isImageSelected) => isImageSelected ? t("Replace from computer") : t("Upload from computer"));
          uploadImageButton.on("execute", () => {
            imageInsertUI.dropdownView.isOpen = false;
          });
          return uploadImageButton;
        }
      });
    }
  }
};

// node_modules/@ckeditor/ckeditor5-image/src/imageupload/imageuploadprogress.js
import "/tmp/build_6afe4207/node_modules/@ckeditor/ckeditor5-image/theme/imageuploadprogress.css";
import "/tmp/build_6afe4207/node_modules/@ckeditor/ckeditor5-image/theme/imageuploadicon.css";
import "/tmp/build_6afe4207/node_modules/@ckeditor/ckeditor5-image/theme/imageuploadloader.css";
var ImageUploadProgress = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "ImageUploadProgress";
  }
  /**
   * @inheritDoc
   */
  constructor(editor) {
    super(editor);
    this.uploadStatusChange = (evt, data, conversionApi) => {
      const editor2 = this.editor;
      const modelImage = data.item;
      const uploadId = modelImage.getAttribute("uploadId");
      if (!conversionApi.consumable.consume(data.item, evt.name)) {
        return;
      }
      const imageUtils = editor2.plugins.get("ImageUtils");
      const fileRepository = editor2.plugins.get(FileRepository);
      const status = uploadId ? data.attributeNewValue : null;
      const placeholder = this.placeholder;
      const viewFigure = editor2.editing.mapper.toViewElement(modelImage);
      const viewWriter = conversionApi.writer;
      if (status == "reading") {
        _startAppearEffect(viewFigure, viewWriter);
        _showPlaceholder(imageUtils, placeholder, viewFigure, viewWriter);
        return;
      }
      if (status == "uploading") {
        const loader = fileRepository.loaders.get(uploadId);
        _startAppearEffect(viewFigure, viewWriter);
        if (!loader) {
          _showPlaceholder(imageUtils, placeholder, viewFigure, viewWriter);
        } else {
          _hidePlaceholder(viewFigure, viewWriter);
          _showProgressBar(viewFigure, viewWriter, loader, editor2.editing.view);
          _displayLocalImage(imageUtils, viewFigure, viewWriter, loader);
        }
        return;
      }
      if (status == "complete" && fileRepository.loaders.get(uploadId)) {
        _showCompleteIcon(viewFigure, viewWriter, editor2.editing.view);
      }
      _hideProgressBar(viewFigure, viewWriter);
      _hidePlaceholder(viewFigure, viewWriter);
      _stopAppearEffect(viewFigure, viewWriter);
    };
    this.placeholder = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
  }
  /**
   * @inheritDoc
   */
  init() {
    const editor = this.editor;
    if (editor.plugins.has("ImageBlockEditing")) {
      editor.editing.downcastDispatcher.on("attribute:uploadStatus:imageBlock", this.uploadStatusChange);
    }
    if (editor.plugins.has("ImageInlineEditing")) {
      editor.editing.downcastDispatcher.on("attribute:uploadStatus:imageInline", this.uploadStatusChange);
    }
  }
};
function _startAppearEffect(viewFigure, writer) {
  if (!viewFigure.hasClass("ck-appear")) {
    writer.addClass("ck-appear", viewFigure);
  }
}
function _stopAppearEffect(viewFigure, writer) {
  writer.removeClass("ck-appear", viewFigure);
}
function _showPlaceholder(imageUtils, placeholder, viewFigure, writer) {
  if (!viewFigure.hasClass("ck-image-upload-placeholder")) {
    writer.addClass("ck-image-upload-placeholder", viewFigure);
  }
  const viewImg = imageUtils.findViewImgElement(viewFigure);
  if (viewImg.getAttribute("src") !== placeholder) {
    writer.setAttribute("src", placeholder, viewImg);
  }
  if (!_getUIElement(viewFigure, "placeholder")) {
    writer.insert(writer.createPositionAfter(viewImg), _createPlaceholder(writer));
  }
}
function _hidePlaceholder(viewFigure, writer) {
  if (viewFigure.hasClass("ck-image-upload-placeholder")) {
    writer.removeClass("ck-image-upload-placeholder", viewFigure);
  }
  _removeUIElement(viewFigure, writer, "placeholder");
}
function _showProgressBar(viewFigure, writer, loader, view) {
  const progressBar = _createProgressBar(writer);
  writer.insert(writer.createPositionAt(viewFigure, "end"), progressBar);
  loader.on("change:uploadedPercent", (evt, name, value) => {
    view.change((writer2) => {
      writer2.setStyle("width", value + "%", progressBar);
    });
  });
}
function _hideProgressBar(viewFigure, writer) {
  _removeUIElement(viewFigure, writer, "progressBar");
}
function _showCompleteIcon(viewFigure, writer, view) {
  const completeIcon = writer.createUIElement("div", { class: "ck-image-upload-complete-icon" });
  writer.insert(writer.createPositionAt(viewFigure, "end"), completeIcon);
  setTimeout(() => {
    view.change((writer2) => writer2.remove(writer2.createRangeOn(completeIcon)));
  }, 3e3);
}
function _createProgressBar(writer) {
  const progressBar = writer.createUIElement("div", { class: "ck-progress-bar" });
  writer.setCustomProperty("progressBar", true, progressBar);
  return progressBar;
}
function _createPlaceholder(writer) {
  const placeholder = writer.createUIElement("div", { class: "ck-upload-placeholder-loader" });
  writer.setCustomProperty("placeholder", true, placeholder);
  return placeholder;
}
function _getUIElement(imageFigure, uniqueProperty) {
  for (const child of imageFigure.getChildren()) {
    if (child.getCustomProperty(uniqueProperty)) {
      return child;
    }
  }
}
function _removeUIElement(viewFigure, writer, uniqueProperty) {
  const element = _getUIElement(viewFigure, uniqueProperty);
  if (element) {
    writer.remove(writer.createRangeOn(element));
  }
}
function _displayLocalImage(imageUtils, viewFigure, writer, loader) {
  if (loader.data) {
    const viewImg = imageUtils.findViewImgElement(viewFigure);
    writer.setAttribute("src", loader.data, viewImg);
  }
}

// node_modules/@ckeditor/ckeditor5-image/src/imageupload/uploadimagecommand.js
var UploadImageCommand = class extends Command {
  /**
   * @inheritDoc
   */
  refresh() {
    const editor = this.editor;
    const imageUtils = editor.plugins.get("ImageUtils");
    const selectedElement = editor.model.document.selection.getSelectedElement();
    this.isEnabled = imageUtils.isImageAllowed() || imageUtils.isImage(selectedElement);
  }
  /**
   * Executes the command.
   *
   * @fires execute
   * @param options Options for the executed command.
   * @param options.file The image file or an array of image files to upload.
   */
  execute(options) {
    const files = toArray(options.file);
    const selection = this.editor.model.document.selection;
    const imageUtils = this.editor.plugins.get("ImageUtils");
    const selectionAttributes = Object.fromEntries(selection.getAttributes());
    files.forEach((file, index) => {
      const selectedElement = selection.getSelectedElement();
      if (index && selectedElement && imageUtils.isImage(selectedElement)) {
        const position = this.editor.model.createPositionAfter(selectedElement);
        this._uploadImage(file, selectionAttributes, position);
      } else {
        this._uploadImage(file, selectionAttributes);
      }
    });
  }
  /**
   * Handles uploading single file.
   */
  _uploadImage(file, attributes, position) {
    const editor = this.editor;
    const fileRepository = editor.plugins.get(FileRepository);
    const loader = fileRepository.createLoader(file);
    const imageUtils = editor.plugins.get("ImageUtils");
    if (!loader) {
      return;
    }
    imageUtils.insertImage({ ...attributes, uploadId: loader.id }, position);
  }
};

// node_modules/@ckeditor/ckeditor5-image/src/imageupload/imageuploadediting.js
var ImageUploadEditing = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get requires() {
    return [FileRepository, Notification, ClipboardPipeline, ImageUtils];
  }
  static get pluginName() {
    return "ImageUploadEditing";
  }
  /**
   * @inheritDoc
   */
  constructor(editor) {
    super(editor);
    editor.config.define("image", {
      upload: {
        types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"]
      }
    });
    this._uploadImageElements = /* @__PURE__ */ new Map();
  }
  /**
   * @inheritDoc
   */
  init() {
    const editor = this.editor;
    const doc = editor.model.document;
    const conversion = editor.conversion;
    const fileRepository = editor.plugins.get(FileRepository);
    const imageUtils = editor.plugins.get("ImageUtils");
    const clipboardPipeline = editor.plugins.get("ClipboardPipeline");
    const imageTypes = createImageTypeRegExp(editor.config.get("image.upload.types"));
    const uploadImageCommand = new UploadImageCommand(editor);
    editor.commands.add("uploadImage", uploadImageCommand);
    editor.commands.add("imageUpload", uploadImageCommand);
    conversion.for("upcast").attributeToAttribute({
      view: {
        name: "img",
        key: "uploadId"
      },
      model: "uploadId"
    });
    this.listenTo(editor.editing.view.document, "clipboardInput", (evt, data) => {
      if (isHtmlIncluded(data.dataTransfer)) {
        return;
      }
      const images = Array.from(data.dataTransfer.files).filter((file) => {
        if (!file) {
          return false;
        }
        return imageTypes.test(file.type);
      });
      if (!images.length) {
        return;
      }
      evt.stop();
      editor.model.change((writer) => {
        if (data.targetRanges) {
          writer.setSelection(data.targetRanges.map((viewRange) => editor.editing.mapper.toModelRange(viewRange)));
        }
        editor.execute("uploadImage", { file: images });
      });
    });
    this.listenTo(clipboardPipeline, "inputTransformation", (evt, data) => {
      const fetchableImages = Array.from(editor.editing.view.createRangeIn(data.content)).map((value) => value.item).filter((viewElement) => isLocalImage(imageUtils, viewElement) && !viewElement.getAttribute("uploadProcessed")).map((viewElement) => {
        return { promise: fetchLocalImage(viewElement), imageElement: viewElement };
      });
      if (!fetchableImages.length) {
        return;
      }
      const writer = new UpcastWriter(editor.editing.view.document);
      for (const fetchableImage of fetchableImages) {
        writer.setAttribute("uploadProcessed", true, fetchableImage.imageElement);
        const loader = fileRepository.createLoader(fetchableImage.promise);
        if (loader) {
          writer.setAttribute("src", "", fetchableImage.imageElement);
          writer.setAttribute("uploadId", loader.id, fetchableImage.imageElement);
        }
      }
    });
    editor.editing.view.document.on("dragover", (evt, data) => {
      data.preventDefault();
    });
    doc.on("change", () => {
      const changes = doc.differ.getChanges({ includeChangesInGraveyard: true }).reverse();
      const insertedImagesIds = /* @__PURE__ */ new Set();
      for (const entry of changes) {
        if (entry.type == "insert" && entry.name != "$text") {
          const item = entry.position.nodeAfter;
          const isInsertedInGraveyard = entry.position.root.rootName == "$graveyard";
          for (const imageElement of getImagesFromChangeItem(editor, item)) {
            const uploadId = imageElement.getAttribute("uploadId");
            if (!uploadId) {
              continue;
            }
            const loader = fileRepository.loaders.get(uploadId);
            if (!loader) {
              continue;
            }
            if (isInsertedInGraveyard) {
              if (!insertedImagesIds.has(uploadId)) {
                loader.abort();
              }
            } else {
              insertedImagesIds.add(uploadId);
              this._uploadImageElements.set(uploadId, imageElement);
              if (loader.status == "idle") {
                this._readAndUpload(loader);
              }
            }
          }
        }
      }
    });
    this.on("uploadComplete", (evt, { imageElement, data }) => {
      const urls = data.urls ? data.urls : data;
      this.editor.model.change((writer) => {
        writer.setAttribute("src", urls.default, imageElement);
        this._parseAndSetSrcsetAttributeOnImage(urls, imageElement, writer);
        imageUtils.setImageNaturalSizeAttributes(imageElement);
      });
    }, { priority: "low" });
  }
  /**
   * @inheritDoc
   */
  afterInit() {
    const schema = this.editor.model.schema;
    if (this.editor.plugins.has("ImageBlockEditing")) {
      schema.extend("imageBlock", {
        allowAttributes: ["uploadId", "uploadStatus"]
      });
    }
    if (this.editor.plugins.has("ImageInlineEditing")) {
      schema.extend("imageInline", {
        allowAttributes: ["uploadId", "uploadStatus"]
      });
    }
  }
  /**
   * Reads and uploads an image.
   *
   * The image is read from the disk and as a Base64-encoded string it is set temporarily to
   * `image[src]`. When the image is successfully uploaded, the temporary data is replaced with the target
   * image's URL (the URL to the uploaded image on the server).
   */
  _readAndUpload(loader) {
    const editor = this.editor;
    const model = editor.model;
    const t = editor.locale.t;
    const fileRepository = editor.plugins.get(FileRepository);
    const notification = editor.plugins.get(Notification);
    const imageUtils = editor.plugins.get("ImageUtils");
    const imageUploadElements = this._uploadImageElements;
    model.enqueueChange({ isUndoable: false }, (writer) => {
      writer.setAttribute("uploadStatus", "reading", imageUploadElements.get(loader.id));
    });
    return loader.read().then(() => {
      const promise = loader.upload();
      const imageElement = imageUploadElements.get(loader.id);
      if (env_default.isSafari) {
        const viewFigure = editor.editing.mapper.toViewElement(imageElement);
        const viewImg = imageUtils.findViewImgElement(viewFigure);
        editor.editing.view.once("render", () => {
          if (!viewImg.parent) {
            return;
          }
          const domFigure = editor.editing.view.domConverter.mapViewToDom(viewImg.parent);
          if (!domFigure) {
            return;
          }
          const originalDisplay = domFigure.style.display;
          domFigure.style.display = "none";
          domFigure._ckHack = domFigure.offsetHeight;
          domFigure.style.display = originalDisplay;
        });
      }
      model.enqueueChange({ isUndoable: false }, (writer) => {
        writer.setAttribute("uploadStatus", "uploading", imageElement);
      });
      return promise;
    }).then((data) => {
      model.enqueueChange({ isUndoable: false }, (writer) => {
        const imageElement = imageUploadElements.get(loader.id);
        writer.setAttribute("uploadStatus", "complete", imageElement);
        this.fire("uploadComplete", { data, imageElement });
      });
      clean();
    }).catch((error) => {
      if (loader.status !== "error" && loader.status !== "aborted") {
        throw error;
      }
      if (loader.status == "error" && error) {
        notification.showWarning(error, {
          title: t("Upload failed"),
          namespace: "upload"
        });
      }
      model.enqueueChange({ isUndoable: false }, (writer) => {
        writer.remove(imageUploadElements.get(loader.id));
      });
      clean();
    });
    function clean() {
      model.enqueueChange({ isUndoable: false }, (writer) => {
        const imageElement = imageUploadElements.get(loader.id);
        writer.removeAttribute("uploadId", imageElement);
        writer.removeAttribute("uploadStatus", imageElement);
        imageUploadElements.delete(loader.id);
      });
      fileRepository.destroyLoader(loader);
    }
  }
  /**
   * Creates the `srcset` attribute based on a given file upload response and sets it as an attribute to a specific image element.
   *
   * @param data Data object from which `srcset` will be created.
   * @param image The image element on which the `srcset` attribute will be set.
   */
  _parseAndSetSrcsetAttributeOnImage(data, image, writer) {
    let maxWidth = 0;
    const srcsetAttribute = Object.keys(data).filter((key) => {
      const width = parseInt(key, 10);
      if (!isNaN(width)) {
        maxWidth = Math.max(maxWidth, width);
        return true;
      }
    }).map((key) => `${data[key]} ${key}w`).join(", ");
    if (srcsetAttribute != "") {
      const attributes = {
        srcset: srcsetAttribute
      };
      if (!image.hasAttribute("width") && !image.hasAttribute("height")) {
        attributes.width = maxWidth;
      }
      writer.setAttributes(attributes, image);
    }
  }
};
function isHtmlIncluded(dataTransfer) {
  return Array.from(dataTransfer.types).includes("text/html") && dataTransfer.getData("text/html") !== "";
}
function getImagesFromChangeItem(editor, item) {
  const imageUtils = editor.plugins.get("ImageUtils");
  return Array.from(editor.model.createRangeOn(item)).filter((value) => imageUtils.isImage(value.item)).map((value) => value.item);
}

// node_modules/@ckeditor/ckeditor5-image/src/imageupload.js
var ImageUpload = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "ImageUpload";
  }
  /**
   * @inheritDoc
   */
  static get requires() {
    return [ImageUploadEditing, ImageUploadUI, ImageUploadProgress];
  }
};
export {
  ImageUpload as default
};
/*! Bundled license information:

@ckeditor/ckeditor5-image/src/imageupload/utils.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-image/src/imageupload/imageuploadui.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-image/src/imageupload/imageuploadprogress.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-image/src/imageupload/uploadimagecommand.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-image/src/imageupload/imageuploadediting.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)
  (* istanbul ignore next -- @preserve *)

@ckeditor/ckeditor5-image/src/imageupload.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)
*/
//# sourceMappingURL=@ckeditor_ckeditor5-image_src_imageupload.js.map
